/**
 * clamp the fraction value to the allowed boundary
 */
export function clampFractionValues(value: number): number {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  // value can be between 0 and 20
  return Math.max(Math.min(value, 20), 0);
}
